import { ModelBase } from '../../core/model/model-base';
import { PostalAddress } from '../../common/model/postal-address';
import { LocalDate } from '../../core/model/local-date';
import { CompanyBankAccount } from '../../rent/model/company-bank-account';
import { SelectionItem } from '../../core/component/select/select.component';

export class RegisterPaymentViewModel {
  companyBankAccounts: CompanyBankAccount[];
  get bankAccountSelection(): SelectionItem[] {
    let result = this.companyBankAccounts.map(acc => new SelectionItem(acc.name, acc.id));
    result.splice(0, 0, new SelectionItem('COMMON.CASH_PAYMENT', ''));
    return result;
  }
}
